import React from "react";

export const DischargeStatusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#166534"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#166534" stroke-width="2" />
      <path
        d="M9 15L11 17L15 13"
        stroke="#166534"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DischargeInitiateCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#15803D" stroke-width="2" />

      <path
        d="M10 14H16"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 12L16 14L14 16"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DischargeInitiatePendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#B91C1C" stroke-width="2" />

      <path
        d="M10 14H16"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 12L16 14L14 16"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NursingClearanceCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#15803D" stroke-width="2" />

      <path
        d="M11 11V15"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M9 13H13"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path
        d="M9 17L11 19L15 15"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NursingClearancePendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#B91C1C" stroke-width="2" />

      <path
        d="M11 11V15"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M9 13H13"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path
        d="M9 17L11 19L15 15"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MedicineReceivedCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3C7.34 3 6 4.34 6 6V10C6 11.66 7.34 13 9 13H11C12.66 13 14 11.66 14 10V6C14 4.34 12.66 3 11 3H9Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M6 8H14" stroke="#15803D" stroke-width="2" />

      <path
        d="M15 7H17C18.1 7 19 7.9 19 9V18C19 19.1 18.1 20 17 20H15C13.9 20 13 19.1 13 18V9C13 7.9 13.9 7 15 7Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 7V5H18V7" stroke="#15803D" stroke-width="2" />

      <path
        d="M9 17L11 19L15 15"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MedicineReceivedPendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3C7.34 3 6 4.34 6 6V10C6 11.66 7.34 13 9 13H11C12.66 13 14 11.66 14 10V6C14 4.34 12.66 3 11 3H9Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M6 8H14" stroke="#B91C1C" stroke-width="2" />

      <path
        d="M15 7H17C18.1 7 19 7.9 19 9V18C19 19.1 18.1 20 17 20H15C13.9 20 13 19.1 13 18V9C13 7.9 13.9 7 15 7Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 7V5H18V7" stroke="#B91C1C" stroke-width="2" />

      <path
        d="M9 17L11 19L15 15"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PharmacyClearanceCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 3H14V6H10V3Z" stroke="#15803D" stroke-width="2" />
      <path
        d="M9 6H15C16.1 6 17 6.9 17 8V18C17 19.1 16.1 20 15 20H9C7.9 20 7 19.1 7 18V8C7 6.9 7.9 6 9 6Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />

      <path
        d="M12 10V14"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M10 12H14"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path
        d="M9 17L11 19L15 15"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PharmacyClearancePendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 3H14V6H10V3Z" stroke="#B91C1C" stroke-width="2" />
      <path
        d="M9 6H15C16.1 6 17 6.9 17 8V18C17 19.1 16.1 20 15 20H9C7.9 20 7 19.1 7 18V8C7 6.9 7.9 6 9 6Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />

      <path
        d="M12 10V14"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M10 12H14"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path
        d="M9 17L11 19L15 15"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BillingCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        ry="2"
        stroke="#15803D"
        stroke-width="2"
      />
      <path d="M3 9H21" stroke="#15803D" stroke-width="2" />
      <path
        d="M7 14H11"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13 14H17"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const BillingPendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        ry="2"
        stroke="#B91C1C"
        stroke-width="2"
      />
      <path d="M3 9H21" stroke="#B91C1C" stroke-width="2" />
      <path
        d="M7 14H11"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13 14H17"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const DischargedCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3H14C15.1 3 16 3.9 16 5V19C16 20.1 15.1 21 14 21H6V3Z"
        stroke="#15803D"
        stroke-width="2"
      />
      <circle cx="12" cy="12" r="0.8" fill="#15803D" />
      <path
        d="M16 12H20"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M18 10L20 12L18 14"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DischargedPendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3H14C15.1 3 16 3.9 16 5V19C16 20.1 15.1 21 14 21H6V3Z"
        stroke="#B91C1C"
        stroke-width="2"
      />
      <circle cx="12" cy="12" r="0.8" fill="#B91C1C" />
      <path
        d="M16 12H20"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M18 10L20 12L18 14"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DischargeSummaryFinalizeCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#15803D" stroke-width="2" />

      <path
        d="M9 15L11 17L15 13"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <rect
        x="14.5"
        y="15.5"
        width="5"
        height="4"
        rx="1"
        stroke="#15803D"
        stroke-width="2"
      />
      <path
        d="M15.5 15.5V14.5C15.5 13.4 16.4 12.5 17.5 12.5C18.6 12.5 19.5 13.4 19.5 14.5V15.5"
        stroke="#15803D"
        stroke-width="2"
      />
    </svg>
  );
};

export const DischargeSummaryFinalizePendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path d="M14 3V9H20" stroke="#B91C1C" stroke-width="2" />

      <path
        d="M9 15L11 17L15 13"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <rect
        x="14.5"
        y="15.5"
        width="5"
        height="4"
        rx="1"
        stroke="#B91C1C"
        stroke-width="2"
      />
      <path
        d="M15.5 15.5V14.5C15.5 13.4 16.4 12.5 17.5 12.5C18.6 12.5 19.5 13.4 19.5 14.5V15.5"
        stroke="#B91C1C"
        stroke-width="2"
      />
    </svg>
  );
};

export const AllowToGoCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="6" r="2" fill="#15803D" />
      <path
        d="M6 20V13C6 11.9 6.9 11 8 11C9.1 11 10 11.9 10 13V20"
        stroke="#15803D"
        stroke-width="2"
      />

      <path
        d="M13 4H17C18.1 4 19 4.9 19 6V18C19 19.1 18.1 20 17 20H13"
        stroke="#15803D"
        stroke-width="2"
      />

      <path
        d="M10 12H15"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13 10L15 12L13 14"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const AllowToGoPendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="6" r="2" fill="#B91C1C" />
      <path
        d="M6 20V13C6 11.9 6.9 11 8 11C9.1 11 10 11.9 10 13V20"
        stroke="#B91C1C"
        stroke-width="2"
      />

      <path
        d="M13 4H17C18.1 4 19 4.9 19 6V18C19 19.1 18.1 20 17 20H13"
        stroke="#B91C1C"
        stroke-width="2"
      />

      <path
        d="M10 12H15"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13 10L15 12L13 14"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BedReleaseCompleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11V8C3 6.9 3.9 6 5 6H8C9.1 6 10 6.9 10 8V11H16C18.2 11 20 12.8 20 15V18H18V15C18 13.9 17.1 13 16 13H3Z"
        stroke="#15803D"
        stroke-width="2"
      />
      <circle cx="6.5" cy="8" r="1.5" fill="#15803D" />

      <path
        d="M13 16H19"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M17 14L19 16L17 18"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BedReleasePendingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11V8C3 6.9 3.9 6 5 6H8C9.1 6 10 6.9 10 8V11H16C18.2 11 20 12.8 20 15V18H18V15C18 13.9 17.1 13 16 13H3Z"
        stroke="#B91C1C"
        stroke-width="2"
      />
      <circle cx="6.5" cy="8" r="1.5" fill="#B91C1C" />

      <path
        d="M13 16H19"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M17 14L19 16L17 18"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
